module.exports = __webpack_public_path__ + "img/index_load_logo@2x.b6d8a607.png";